import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { Bar, getElementsAtEvent } from "react-chartjs-2";

// Register necessary plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

interface ISalesGraph {
  data: any;
  onSelect: any;
}

export const SalesGraph = ({ data, onSelect }) => {
  const ref = React.useRef();

  const onClick = (e) => {
    if (getElementsAtEvent(ref.current!, e).length > 0) {
      console.log(getElementsAtEvent(ref.current!, e));
      let datasetIndex = getElementsAtEvent(ref.current!, e)[0].datasetIndex;
      let dataPoint = getElementsAtEvent(ref.current!, e)[0].index;

      console.log({
        datasetIndex,
        dataPoint,
        data: data[dataPoint],
      });

      onSelect(data[dataPoint]);
    }
  };

  // Helper function to calculate median
  const calculateMedian = (arr) => {
    const sorted = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0
      ? sorted[mid]
      : (sorted[mid - 1] + sorted[mid]) / 2;
  };

  if (data) {
    // Extract sales data for calculations
    const salesData = data?.map((scan) => scan.salesSum);

    // Calculate the average and median
    const average = salesData.reduce((a, b) => a + b, 0) / salesData.length;
    const median = calculateMedian(salesData);

    return (
      <div>
        <Bar
          className="cursor-pointer"
          ref={ref}
          onClick={onClick}
          options={{
            responsive: true,
            maintainAspectRatio: true,
            plugins: {
              legend: {
                display: false,
              },
              tooltip: {
                backgroundColor: 'rgba(30, 41, 59, 0.95)',
                padding: 12,
                borderColor: 'rgba(51, 65, 85, 1)',
                borderWidth: 1,
                titleColor: '#fff',
                bodyColor: '#fff',
                cornerRadius: 8,
              },
              annotation: {
                annotations: {
                  averageLine: {
                    type: "line",
                    yMin: average,
                    yMax: average,
                    borderColor: "rgb(96, 165, 250)",
                    borderWidth: 2,
                    borderDash: [5, 5],
                    label: {
                      content: `Moyenne: ${average.toFixed(2)} pcs`,
                      display: true,
                      position: "end",
                      backgroundColor: "rgba(96, 165, 250, 0.9)",
                      color: "#fff",
                      yAdjust: -10,
                      borderRadius: 6,
                      padding: 6,
                      font: {
                        size: 11,
                        weight: 'bold',
                      },
                    },
                  },
                },
              },
            },
            scales: {
              x: {
                grid: {
                  display: false,
                },
                ticks: {
                  color: '#6B7280',
                  font: {
                    size: 11,
                  },
                },
              },
              y: {
                type: "linear" as const,
                display: true,
                position: "left" as const,
                border: {
                  display: false,
                },
                grid: {
                  color: 'rgba(0, 0, 0, 0.05)',
                  drawTicks: false,
                },
                ticks: {
                  color: '#6B7280',
                  font: {
                    size: 11,
                  },
                  padding: 8,
                  callback: function (value) {
                    return Number.isInteger(value) ? value + " pcs" : null;
                  },
                },
              },
            },
          }}
          data={{
            labels: data?.map((scan) => {
              // format scan.createdAt date to be displayed dd/mm/yyyy hh:mm
              let date = new Date(scan.createdAt);

              // Tableau des jours de la semaine
              const joursSemaine = [
                "dim",
                "lun",
                "mar",
                "mer",
                "jeu",
                "ven",
                "sam",
              ];

              // Récupérer les différentes parties de la date
              let jourSemaine = joursSemaine[date.getDay()]; // jour de la semaine
              let jour = date.getDate().toString().padStart(2, "0"); // jour du mois
              let mois = (date.getMonth() + 1).toString().padStart(2, "0"); // mois, +1 car les mois commencent à 0
              let annee = date.getFullYear(); // année
              let heures = date.getHours().toString().padStart(2, "0"); // heures, avec ajout d'un 0 si nécessaire

              return `${jourSemaine} ${jour}/${mois}`;
            }),
            datasets: [
              {
                label: "pcs vendues",
                data: salesData,
                backgroundColor: "rgba(96, 165, 250, 0.65)",
                borderColor: "rgba(96, 165, 250, 1)",
                borderWidth: 0,
                borderRadius: 6,
                hoverBackgroundColor: "rgba(96, 165, 250, 0.8)",
              },
            ],
          }}
        />
      </div>
    );
  }

  return null;
};
